<template>
  <div>
    <a-form-model ref="form" :model="model" :rules="validatorRules" class="password-retrieval-form">

      <a-form-model-item :label="language['portal.ui2.account']" v-bind="layout"> <!-- 账号 -->  
        <a-input type="text" :value="accountName" disabled/>
      </a-form-model-item>

      <a-form-model-item prop="password" :label="language['portal.ui2.mobile.newPwd']" v-bind="layout" class="stepFormText">  <!-- 新密码 -->
        <a-input-password v-model="model.password" type="password" autocomplete="false"/>
      </a-form-model-item>

      <a-form-model-item prop="confirmPassword" :label="language['portal.ui2.mobile.confirmPwd']" v-bind="layout" class="stepFormText">  <!-- 确认密码 -->
        <a-input-password v-model="model.confirmPassword" type="password" autocomplete="false" @blur="handleConfirmBlur"/>
      </a-form-model-item>

      <a-form-model-item :wrapperCol="{span: 19, offset: 5}">
        <a-button style="margin-left: 8px" @click="prevStep">{{ language['ese.previous'] }}</a-button>  <!-- 上一步 -->
        <a-button :loading="loading" type="primary" @click="nextStep" style="margin-left:20px">{{ language['common.submitButton'] }}</a-button>  <!-- 提交 -->
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  export default {
    name: "Step3",
//    components: {
//      Result
//    },
    props: ['userList'],
    data () {
      const { language } = this.$store.getters; 
      return {
        disabledPassworld:[],
        disabledPassworldStr:'',
        confirmDirty:false,
        model:{},
        layout: {
          labelCol: { span: 5 },
          wrapperCol: { span: 19 },
        },
        loading: false,
        accountName: this.userList.username,
        /*validatorRules: {
          password: [{ 
            required: true, pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,}$/,
            message: language['portal.ui2.pwdRule']  //密码由8位数字、大小写字母和特殊符号组成!
          }],
          confirmPassword: [
            { required: true, message: language['system.loginPassword']}, //密码不能为空 请输入密码
            { validator: this.handlePasswordCheck}
          ]
        }*/
      }
    },
    created () {
      console.log("created");
      getAction("/sys/dictItem/queryPlatformBlackPassword").then(res=> {
        if (res.success) {
          let list = res.result;
          this.disabledPassworld = list
          this.disabledPassworldStr = list.map(item => item.value.trim()).join(', ')
        }
      })
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        return {
          /*password: [{
            required: true, pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,}$/,
            message: this.$store.getters.language['portal.ui2.pwdRule']  //密码由8位数字、大小写字母和特殊符号组成!
          }],
          confirmPassword: [
            { required: true, message: this.$store.getters.language['system.loginPassword']}, //密码不能为空 请输入密码
            { validator: this.handlePasswordCheck}
          ]*/
          password: [{
              required: true,
              pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{12,}$/,
              message: this.$store.getters.language['warning.passwordConsists'].replace("${passwordDisabled}", this.disabledPassworldStr)
            }, {
              validator: this.validateToNextPassword,
            }],
          confirmPassword:[{
              required: true, message: this.$store.getters.language['system.loginPassword']
            }, {
              validator: this.handlePasswordCheck,
            }],
        }
      }
    },
    methods: {
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      },
      validateToNextPassword  (rule, value, callback) {
        if (value && this.model.confirmPassword && value !== this.model.confirmPassword) {
          callback(this.language['portal.front.password.two.inconsistent']);
        }
        /*if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }*/
        if(!!this.disabledPassworld&&this.disabledPassworld.length>0&&value.match(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,}$/)){
          for(var i=0;i<this.disabledPassworld.length;i++){
            let item = this.disabledPassworld[i];
            if(value.includes(item.value.trim())){
              callback(this.$store.getters.language['warning.passwordConsists'].replace("${passwordDisabled}", this.disabledPassworldStr));
            }
          }
        }
        callback();
      },
      nextStep () {
        let that = this
        that.loading = true
        that.$refs['form'].validate(success => {
          if (success === true) {
            let params = {
              username: that.userList.username,
              password: that.model.password,
              smscode: that.userList.smscode,
              phone: that.userList.phone,
            }
            getAction("/sys/user/passwordChangeByEmail", params).then((res) => {
              if (res.success) {
                let userList = {
                  username: that.userList.username
                }
                setTimeout(function() {
                  that.$emit('nextStep', userList)
                }, 1500)
              } else {
                that.passwordFailed(res.message);
                that.loading = false
              }
            })
          } else {
            that.loading = false
          }
        })
      },
      prevStep () {
        this.$emit('prevStep', this.userList)
      },

      handlePasswordCheck (rule, value, callback) {
        let password = this.model['password']
        if (value && password && value.trim() !== password.trim()) {
          callback(new Error(this.language['portal.front.password.two.inconsistent'])) //两次密码不一致
        }
        this.$refs.form.validateField(['password']);
        callback()
      },
      passwordFailed(err){
        this.$notification[ 'error' ]({
          message: this.language['system.changePwdFail'], //更改密码失败
          description:err,
          duration: 4,
        });
      },
    }
  }
</script>
<style lang="less" scoped>
  .stepFormText {
    margin-bottom: 24px;
  }

  .ant-form-item-label,
  .ant-form-item-control {
    line-height: 22px;
  }

</style>